import { IMithrilComponent } from '../../components/mithril.component';
import { Spinner } from '../../components/spinner/spinner';
import { addStyles } from '../../components/theme';
import { T, Translate } from '../../i18n';
import { m } from '../../mithril';
import { Services } from '../../services';
import { classNames } from '../../util/classnames';

import { IkePageName } from '../../page/page';
import { CSS, Style } from './auth.component.style';

addStyles(Style);

export class SSOLoginComponent extends IMithrilComponent {
	viewButton() {
		return m(
			'button',
			{
				className: classNames('mdl-button', 'mdl-button--raised', CSS.button),
				onclick: () => Services.SSO.login(),
			},
			Translate(T.LOGIN_WITH_AUTH0)
		);
	}
	get nodes() {
		// remove the flash of the login screen as the user is authenticating!
		// the ui renders before the sso authenticate state resolves, so without
		// this it feels janky.
		if (Services.SSO.inFlight || Services.SSO.isAuthenticated) {
			return m(
				'div',
				{
					className: CSS.container,
				},
				m(
					'div',
					{
						className: CSS.centered,
					},
					Spinner.view()
				)
			);
		}

		return m(
			'div',
			{
				className: CSS.container,
			},
			[
				m(
					'div',
					{
						className: CSS.text,
					},
					m(
						'div',
						{
							className: CSS.textInner,
						},
						Translate(T.LOGIN_OFFICE)
					)
				),

				m(
					'div',
					{
						className: CSS.padding,
					},
					this.viewButton()
				),

				m(
					'div',
					{
						className: CSS.padding,
					},
					m(
						'a',
						{
							className: CSS.link,
							onclick: () => Services.Route.go(IkePageName.userSSOMigrate),
						},
						Translate(T.LOGIN_NO_AUTH0_ACCOUNT)
					)
				),
			]
		);
	}
}
